import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import useIncomingCallPatients from "./use-incoming-call-patients.hook";

const MAX_BUTTONS = 3;

type IncomingCallSnackbarActionProps = {
  patientIds: number[];
};

// "View patient" buttons inside the global snackbar's action slot for users
// without a connected softphone. Appointment-sorted; loading renders nothing
// (the snackbar text already names the caller).
export default function IncomingCallSnackbarAction({
  patientIds
}: IncomingCallSnackbarActionProps) {
  const navigate = useNavigate();
  const { patients, isLoading } = useIncomingCallPatients(patientIds);

  if (isLoading || patients.length === 0) return null;

  const visible = patients.slice(0, MAX_BUTTONS);
  const hiddenCount = patients.length - visible.length;

  const label = (index: number) => {
    const patient = visible[index];
    const first = patient.first_name ?? "";
    const last = patient.last_name ?? "";
    return visible.length === 1
      ? `View ${`${first} ${last}`.trim() || "patient"}`
      : `${first} ${last.charAt(0)}${last ? "." : ""}`.trim();
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {visible.map((patient, index) => (
        <Button
          key={patient.id}
          color="inherit"
          size="small"
          onClick={() => navigate(`/patients/${patient.id}`)}
        >
          {label(index)}
        </Button>
      ))}
      {hiddenCount > 0 && (
        <Typography variant="caption">+{hiddenCount} more</Typography>
      )}
    </Stack>
  );
}
